<template>
  <div class="teamwork TopHeadder">
      <!-- 智能ivr -->
      <div class="bannerBox">
          <img src="../assets/image/t_banner.jpg" />
           <div class="bannerTitle">
             <h3>小语与您共享千亿电销/客服市场</h3>
             <p>我们期待与您合作、共赢未来，小语诚邀您的加入</p>
          </div>
      </div>

      <div class="PublicPadding">
         <h4 class="title">小语独一无二的优势</h4>
         <h5 class="titleh5">全智能saas销售客服解决方案供应商</h5>
         <div class="PublicUl">
            <ul class="clear PublicStyle">
                <li>
                    <i><img src="../assets/image/t_1.jpg" /></i>
                    <h6>产品竞争力</h6>
                    <p>14年技术研发经验，产品实力更强大</p> 
                </li>
                <li>
                    <i><img src="../assets/image/t_2.jpg" /></i>
                    <h6>市场分析</h6>
                    <p>人工智能广袤的市场前景</p> 
                </li>
                <li>
                    <i><img src="../assets/image/t_3.jpg" /></i>
                    <h6>售前支持</h6>
                    <p>7x24小时全方位服务一对一售前支持</p> 
                </li>
                <li>
                    <i><img src="../assets/image/t_4.jpg" /></i>
                    <h6>品牌运营</h6>
                    <p>全媒体品牌宣传推广，完善的销售持续支持</p> 
                </li>
            </ul>
         </div>  
      </div>
      <div class="PublicPadding t_item2">
         <h4 class="title">小语为合作伙伴提供支持</h4>
         <h5 class="titleh5">您的成功是我们的成就</h5>
         <div class="t_text">
            <img src="../assets/image/t_b.png" class="item2_img"/>
            <ul>
               <li class="item2_li1">
                  <p>强大的功能 完美的客户体验 灵活的部署模式</p>
                  <h4>产品支持</h4>
               </li>
               <li class="item2_li2"> 
                  <h4>市场支持</h4>
                  <p>产品宣传资料支持
                     品牌支持
                     媒体支持
                  </p>
               </li>
               <li class="item2_li3"> 
                  <h4>培训支持</h4>
                  <p>产品定位</br>
                     目标客户</br>
                     销售管理等</br>
                     全方位多层次</br>
                     系统培训
                  </p>
               </li>
               <li class="item2_li4"> 
                  <h4>销售支持</h4>
                  <p>售前支持 售中指导 售后协助</p>
                 
               </li>
            </ul>
         </div>
      </div>
      <div class="PublicPadding t_item3">
         <h4 class="title">合作条件</h4>
         <h5 class="titleh5">您可以是：通讯公司/运营商/房产公司/保险/销售/医疗供应商等</h5>
         <div>
             <i><img src="../assets/image/t3_t.jpg"/></i>
             <p><s>·</s>有良好的意愿，能提供优质的商品、良好的售后服务并保证合作的顺利开展。</p>
             <p><s>·</s>有志在中国人工智能行业长远发展并获得成功。</p>
             <p><s>·</s>接受特许经营的商业模式，认可小语的企业文化。</p>
         </div>
      </div>
     <Popup v-show="$store.state.isshow"></Popup>
  </div>
</template>

<script>
import Popup from "@/components/popup"
export default {
  name: 'teamwork',
  data () {
    return {
     
    }
  },
  components:{
       Popup
  },
  methods:{
   
  }
}
</script>


<style scoped>
.bannerTitle{
    left:0.1rem;
    width:100%;
    top:1.5rem;
}
.bannerTitle h3{
    font-size:0.36rem;
    text-align:center;
}
.bannerTitle p{
     text-align:center;
}
.PublicUl ul li i{
    width:0.87rem;
    height:0.8rem;
}
.PublicUl ul li i img{
    width:0.87rem;
    height:0.8rem;
}
.t_item2{
    margin-top:0.2rem;
}
.t_text{
   position:relative;
}
.t_item2 img.item2_img{
    display:block;
    width:4.22rem;
    height:4.27rem;
    margin:0 auto;
    margin-top:1.4rem;
    margin-bottom:0.8rem;
}
.t_item2 ul li img{
    display:block;
    width:0.6rem;
    height:0.6rem;
}
.t_item2 ul li{
    position:absolute;
}
.t_item2 ul li p{
    font-size:0.2rem;
    color:#666;
    text-align:center;
}
.t_item2 ul li h4{
    font-size:0.26rem;
    color:#333;
    text-align:center;
}
.t_item2 ul li.item2_li1{
   top:-0.8rem;
   left:1.5rem;
}
.t_item2 ul li.item2_li2{
   width:1.1rem;
   top:1.4rem;
   left:0.5rem;
}
.t_item2 ul li.item2_li3{
   width:1.4rem;
   top:1.4rem;
   right:0.3rem;
}
.t_item2 ul li.item2_li4{
   bottom:-0.8rem;
   left:2.3rem;
}
.t_item3{
    margin-top:0.2rem;
    padding-left:0.3rem;
    padding-right:0.3rem;
}
.t_item3 div{
     box-shadow: 0 0 8px #ccc;
    border-radius: 8px;
    padding:0.2rem;
    margin-top:0.3rem;
    padding-bottom:0.4rem;
}
.t_item3 i{
   display:block;
   width:3.53rem;
   height:3.67rem;
   margin:0.2rem auto;
}
.t_item3 i img{
   display:block;
   width:3.53rem;
   height:3.67rem;
}
.t_item3 p s{
    font-weight:600;
    color:#307EFF;
    margin:0 0.1rem;
}
.t_item3 p{
    font-size:0.22rem;
    color:#666;
}
</style>



// WEBPACK FOOTER //
// src/components/teamwork.vue